import React from 'react';

interface CheckBoxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  label,
  checked,
  onChange,
  disabled = false
}) => {
  return (
    <label className="flex items-center space-x-1.5 sm:space-x-2 cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="form-checkbox h-3.5 w-3.5 sm:h-4 sm:w-4 text-primary transition duration-150 ease-in-out flex-shrink-0"
      />
      <span className={`text-xs sm:text-sm ${disabled ? 'text-muted-foreground' : 'text-foreground'}`}>
        {label}
      </span>
    </label>
  );
};

export default CheckBox;